const API_URL = import.meta.env.VITE_API_URL || '';

const DEMO_MODE = import.meta.env.DEV === true && import.meta.env.VITE_DEMO_MODE === 'true';

function getToken() {
  return localStorage.getItem('token') || '';
}

const DEMO_READ_PATHS = new Set(['/api/professionals', '/api/providers', '/api/appointments']);

export async function apiFetch(path, options = {}) {
  if (DEMO_MODE) {
    if (String(options.method || 'GET').toUpperCase() !== 'GET') {
      throw new Error('DEMO_WRITE_DISABLED: Las demostraciones no guardan cambios.');
    }
    if (!DEMO_READ_PATHS.has(path)) {
      throw new Error('DEMO_FIXTURE_UNAVAILABLE: Esta ruta requiere una API configurada.');
    }
    return { ok: true, data: [], demo: true, source: 'development_fixture' };
  }

  const token = getToken();

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    throw new Error('Sesión expirada');
  }

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || `Error ${res.status}`);
  }

  return data;
}

export async function login(email, password, tenant_id) {
  if (DEMO_MODE) {
    throw new Error('DEMO_AUTH_DISABLED: La autenticación requiere una API configurada.');
  }

  const res = await fetch(`${API_URL}/api/saas/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, tenant_id }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || 'Error de login');
  }

  // 2FA: si la cuenta tiene celular registrado, el login no da token todavía — hay que
  // completar verify2FA() con el código que llega por WhatsApp.
  if (data.requires_2fa) return data;

  if (data.token) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('tenant_id', data.tenant_id);
    localStorage.setItem('user', JSON.stringify(data.user));
  }

  return data;
}

export async function verify2FA(email, code) {
  if (DEMO_MODE) throw new Error('DEMO_AUTH_DISABLED: La autenticación requiere una API configurada.');
  const res = await fetch(`${API_URL}/api/saas/2fa/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Código inválido');

  if (data.token) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('tenant_id', data.tenant_id);
    localStorage.setItem('user', JSON.stringify(data.user));
  }

  return data;
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('tenant_id');
  localStorage.removeItem('user');
}

export function getUser() {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
}

export function isLoggedIn() {
  return !!getToken();
}
